import ManagementTable from "../../../components/pages/Management/ManagementTable/ManagementTable";
import useGetAllYachts from "../../../components/pages/Management/Yachts/useGetAllYachts";
import Breadcrumbs from "../../../components/shared/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../../../styled";
import ManagementSearch from "../../../components/pages/Management/ManagementSearch/ManagementSearch";
import { ButtonWrapper } from "../../Settings/AccountDetails/AccountDetails.styled";

const FleetYachts = () => {
  const { yachts, isLoading } = useGetAllYachts();

  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonWrapper>
          <ManagementSearch
            section={"_fleet_yachts"}
            refetch={() => {}}
            currentRequestParams={{}}
          />
        </ButtonWrapper>
      </Breadcrumbs>

      <ManagementTable
        data={yachts}
        loading={isLoading}
        section="_fleet_yachts"
      />
    </PageContainer>
  );
};
export default FleetYachts;
